import {getStore, setStore, removeStore} from '../../utils/storage.js'

const state = {
  // 历史布局及活动视频节点数组
  layout: getStore('liveVideoLayout') ? JSON.parse(getStore('liveVideoLayout')) : { name: '四画面', count: 4 },
  activeStreamNodes: getStore('liveVideoActiveStreamNodes') ? JSON.parse(getStore('liveVideoActiveStreamNodes')) : []
}

const mutations = {
  SET_LAYOUT: (state, layout) => {
    state.layout = layout
    setStore('liveVideoLayout', JSON.stringify(layout))
  },
  SET_ACTIVE_STREAM_NODES: (state, streamNodes) => {
    state.activeStreamNodes = streamNodes
    setStore('liveVideoActiveStreamNodes', JSON.stringify(streamNodes))
  },
  CLEAR_LAYOUT: (state) => {
    state.layout = null
    state.activeStreamNodes = []
    removeStore('liveVideoLayout')
    removeStore('liveVideoActiveStreamNodes')
  }
}

const actions = {

}

const getters = {}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/live-video.js